import { useSelector, useDispatch } from 'react-redux';
import TreeView from "./TreeView";
import { getRuleById, initializeAuth, getTreeById } from "../../services/apiService";
import { setSelectedRule, setRuleTab, setRuleTree } from '../../redux/rulesSlice';
import { useMsal } from "@azure/msal-react";

export const TreeSearch = () => {
  const { instance, accounts } = useMsal();
  const { searchTree, searchTerm } = useSelector(state => state.rules);
  const dispatch = useDispatch();

 const handleItemSelect = async (item) => {
    if (item && item.parentId === -1) {
        dispatch(setSelectedRule({}));
        await initializeAuth(instance, accounts);
        console.log("Selected RulesetGroup:", item.id);
        const response = await getTreeById(item.id);
        dispatch(setRuleTab('rule'));
        dispatch(setRuleTree(response));
    }
    else if (item && item.id) {
      await initializeAuth(instance, accounts);
      const rule = await getRuleById(item.id);
      console.log("Selected Rule:", rule);
       dispatch(setSelectedRule(rule));
    }
  };
  if (searchTerm !== '' && searchTree.length === 0) {
    return 'No results.';
  }

  return <TreeView data={searchTree} onItemSelect={(item) => handleItemSelect(item)} />;
};
